import { ArrowDownIcon, ArrowUpIcon } from '@chakra-ui/icons';
import { IconButton, ButtonProps } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

type CollapseButtonProps = ButtonProps & {
  isOpen: boolean;
  toggleIsOpen: () => void;
};

export const CollapseButton: React.FC<CollapseButtonProps> = ({
  isOpen,
  toggleIsOpen,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <IconButton
      aria-label={translate('expandTile')}
      icon={isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
      onClick={toggleIsOpen}
      isRound
      {...props}
    />
  );
};
